import React from "react";
import Header from "../components/Header";
import SiteBanner from "../components/SiteBanner";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import ChatbotWidget from "../components/ChatbotWidget";
import NewsletterBand from "../components/NewsletterBand";
import CookieBanner from "../components/CookieBanner";
import usePageviewTracker from "../hooks/usePageviewTracker";

export default function StorefrontLayout({ children }) {
  usePageviewTracker();
  return (
    <div className="min-h-screen bg-berulia-beige text-berulia-ink font-body">
      <SiteBanner/>
      <Header/>
      <main>{children}</main>
      <NewsletterBand/>
      <Footer/>
      <CartDrawer/>
      <ChatbotWidget/>
      <CookieBanner/>
    </div>
  );
}
